import { message } from 'antd';
import axios from 'axios';
import { useQueryClient, useMutation, useQuery } from 'react-query';
import { LocationsApi } from '../api-client';

const locationsApi = new LocationsApi();

export function useLocations(data?: { skip?: number; take?: number }) {
  return useQuery(['locations', data], async () => {
    const api = new LocationsApi();
    const response = await api.locationControllerFindLocations(
      data?.skip,
      data?.take
    );
    return response.data;
  });
}

export function useCreateLocationTag() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locationTags', 'create'],
    (data: {
      name: string;
      description: string;
      pay: number;
      textColor: string;
      backgroundColor: string;
    }) => {
      return axios.post('/location_tags', data);
    },
    {
      onSuccess: () => {
        message.success('新增成功');
        queryClient.invalidateQueries('locationTags');
        queryClient.invalidateQueries('driversSalary');
      },
    }
  );
}

export function useUpdateLocationTag() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locationTags', 'update'],
    (data: {
      id: string;
      name: string;
      description: string;
      pay: number;
      textColor: string;
      backgroundColor: string;
    }) => {
      return axios.patch(`/location_tags/${data.id}`, data);
    },
    {
      onSuccess: () => {
        message.success('更新成功');
        queryClient.invalidateQueries('locationTags');
        queryClient.invalidateQueries('driversSalary');
      },
    }
  );
}

export function useDeleteLocationTag() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locationTags', 'delete'],
    (id: string) => {
      return axios.delete(`/location_tags/${id}`);
    },
    {
      onSuccess: () => {
        message.success('刪除成功');
        queryClient.invalidateQueries('locationTags');
        queryClient.invalidateQueries('driversSalary');
      },
    }
  );
}

export function useCreateLocation() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locations', 'create'],
    (data: {
      name: string;
      idNumber: number;
      backgroundColor: string;
      address: string | null;
      comment: string | null;
      recycleBagsWeight: number;
      city: string | null;
      district: string | null;
    }) => {
      return axios.post('/locations', data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('locations');
        message.success('新增成功');
      },
    }
  );
}

export function useUpdateLocation() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locations', 'update'],
    (data: {
      id: string;
      name: string;
      idNumber: number;
      backgroundColor: string;
      address: string | null;
      comment: string | null;
      recycleBagsWeight: number;
      city: string | null;
      district: string | null;
    }) => {
      return axios.patch(`/locations/${data.id}`, data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('locations');
        message.success('更新成功');
      },
    }
  );
}

export function useDeleteLocation() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locations', 'delete'],
    (id: string) => {
      return axios.delete(`/locations/${id}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('locations');
        message.success('刪除成功');
      },
    }
  );
}

export function useLocationTags() {
  return useQuery('locationTags', async () => {
    const response = await axios.get('/location_tags');

    return response.data;
  });
}

export function useUpdateCooperationState() {
  const queryClient = useQueryClient();

  return useMutation(
    ['locations', 'updateState'],
    (data: { id: string }) => {
      return new LocationsApi().locationControllerToggleStatus(data.id);
    },
    {
      onSuccess: () => {
        message.success('合作狀態更新成功');
        queryClient.invalidateQueries('locations');
      },
    }
  );
}

export function useListLocation() {
  return useQuery({
    queryKey: ['locations'],
    queryFn: () => {
      return locationsApi.locationControllerListLocations().then((res) => {
        return res.data;
      });
    },
  });
}
